import React from 'react'

import Box from '@material-ui/core/Box'
import PropTypes from 'prop-types'
import { ReactComponent as BlockedCompass } from 'Assets/Icons/blocked-compass.svg'
import { Modal } from 'Components/atoms'

import { Description } from './styled'

const ModalBlockedCenter = ({ showModal, setShowModal, msg }) => (
  <Modal
    displayModal='flex'
    margin='1rem'
    showClose
    isOpen={showModal}
    setIsOpen={setShowModal}
    maxHeight='20rem'
    maxWidth='40rem'
  >
    <Box alignSelf='center' alignItems='center' flex={1}>
      <BlockedCompass width={100} height={100} />

      <Description>{msg}</Description>
    </Box>
  </Modal>
)

ModalBlockedCenter.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  msg: PropTypes.string,
}

ModalBlockedCenter.defaultProps = {
  showModal: false,
  setShowModal: () => {},
  msg: '',
}

export default ModalBlockedCenter
